import { Navbar, Hero, Services, Process, ContactForm, Footer } from '../../components';

export const BaseApp = () => (
  <div>
    <Navbar />
    <Hero />
    <Services />
    <Process />
    <ContactForm />
    <Footer />
  </div>
);

export default BaseApp;
